export default "__VITE_ASSET__eJHvrWkg__"